import React from 'react'
import injectStyles from 'react-jss'

import AddIcon from '@material-ui/icons/Add'

import MetricRow from './MetricRow'
import './types'
import StyledIconButton from '../Form/StyledIconButton'
import { styles } from './styles'
import { useDispatch } from 'react-redux'
import { hideReduxModal, showReduxModal } from '../../Reducers/UI/actions'
import { STATUS_CAMPAIGN_ENUM_DRAFT } from '../../shared/constants'
import SimpleCheckbox from '../../Assets/Images/icons/checkbox'

/**
 * The UI for editing metrics.
 * @param {MetricsEditProps} props
 */
const MetricsEdit = props => {
  var {
    defaultMetrics = [],
    campaign,
    metrics = [],
    onMetricUpdate = function() {},
    onMetricDelete = function() {},
    onMetricAdd = function() {},
    onPrimaryIndexChange = function() {},
    primaryIndex,
    conversionToggle,
    scansToggle,
    toggleConversionApi,
    toggleScans,
    flyerCodeToggle,
    toggleFlyerCode,
    canMetricEdit,
    setCanMetricEdit,
    classes,
  } = props
  // Utility funciton for handling a metric prop change
  const dispatch = useDispatch()
  const onNameChange = (id, value) => onMetricUpdate(id, 'name', value)

  const onLabelChange = (id, value) => {
    onMetricUpdate(id, 'label', value)
  }

  const onTargetConversionRateChange = (id, value) =>
    onMetricUpdate(id, 'targetConversionRate', value)

  const onTargetCostPerMetricChange = (id, value) =>
    onMetricUpdate(id, 'targetCostPerMetric', value)

  const conversionApiAction = () => {
    if (
      campaign &&
      campaign.status !== STATUS_CAMPAIGN_ENUM_DRAFT &&
      conversionToggle
    ) {
      return dispatch(
        showReduxModal({
          title: 'Warning',
          children:
            'Only uncheck this box if the client definitely did not provide any data via the Conversion API. Do you really want to uncheck it?',
          onConfirm: () => toggleConversionApi(conversionToggle),
          onCancel: () => {
            dispatch(hideReduxModal())
          },
        }),
      )
    } else {
      toggleConversionApi(conversionToggle)
    }
  }

  const flyerCodeAction = () => {
    if (
      campaign &&
      campaign.status !== STATUS_CAMPAIGN_ENUM_DRAFT &&
      flyerCodeToggle
    ) {
      return dispatch(
        showReduxModal({
          title: 'Warning',
          children:
            'Unchecking this lets Brand Ambassadors check in WITHOUT scanning or assigning a flyer code (an internal code is auto-assigned behind the scenes). Only do this for campaigns with no flyers/QR codes, e.g. book boxes. Uncheck it?',
          onConfirm: () => toggleFlyerCode(flyerCodeToggle),
          onCancel: () => {
            dispatch(hideReduxModal())
          },
        }),
      )
    } else {
      toggleFlyerCode(flyerCodeToggle)
    }
  }

  const scanAction = () => {
    if (
      campaign &&
      campaign.status !== STATUS_CAMPAIGN_ENUM_DRAFT &&
      scansToggle
    ) {
      return dispatch(
        showReduxModal({
          title: 'Warning',
          children:
            'Unchecking this will hide all scans related data and graphs from the campaign dashboard and master schedule. Do you really want to uncheck it?',
          onConfirm: () => toggleScans(scansToggle),
          onCancel: () => {
            dispatch(hideReduxModal())
          },
        }),
      )
    } else {
      toggleScans(scansToggle)
    }
  }

  return (
    <div>
      <div className={classes.actionsContainer}>
        <div className={classes.action}>
          <div className={classes.checkboxContainer}>
            <div
              className={classes.checkbox}
              onClick={() => conversionApiAction(conversionToggle)}
            >
              <SimpleCheckbox isChecked={conversionToggle} />
            </div>
            <p className={classes.checkboxLabel}>Conversion API</p>
          </div>

          <p className={classes.actionDescription}>
            Check this if the client is providing conversion data for this
            campaign via Promofy’s Conversion API.
          </p>
        </div>

        <div className={classes.action}>
          <div className={classes.checkboxContainer}>
            <div
              className={classes.checkbox}
              onClick={() => scanAction(scansToggle)}
            >
              <SimpleCheckbox isChecked={scansToggle} />
            </div>
            <p className={classes.checkboxLabel}>Scans data</p>
          </div>
          <p className={classes.actionDescription}>
            Check this if this campaign has flyers that are scannable and we can
            collect scans data from. If unchecked, we will hide all scans
            related data and graphs from the campaign dashboard and master
            schedule.
          </p>
        </div>

        <div className={classes.action}>
          <div className={classes.checkboxContainer}>
            <div
              className={classes.checkbox}
              onClick={() => flyerCodeAction(flyerCodeToggle)}
            >
              <SimpleCheckbox isChecked={flyerCodeToggle} />
            </div>
            <p className={classes.checkboxLabel}>
              Flyer codes required at check-in
            </p>
          </div>
          <p className={classes.actionDescription}>
            Check this if Brand Ambassadors must scan or pick a flyer code when
            checking in. Uncheck only for campaigns with no flyers/QR codes
            (e.g. book boxes) — check-in then needs just the stock photo and a
            selfie.
          </p>
        </div>
      </div>
      <div className={classes.divider} />
      {metrics.map((m, i) => {
        return (
          <MetricRow
            {...m}
            allMetrics={metrics}
            defaultMetrics={defaultMetrics}
            setCanMetricEdit={setCanMetricEdit}
            canMetricEdit={canMetricEdit}
            onNameChange={onNameChange}
            onTargetConversionRateChange={onTargetConversionRateChange}
            onTargetCostPerMetricChange={onTargetCostPerMetricChange}
            onStandartMetricChange={onLabelChange}
            isPrimary={i == primaryIndex}
            onPrimaryMetricToggle={onPrimaryIndexChange.bind(this, i)}
            onDelete={onMetricDelete}
          />
        )
      })}
      <div className={classes.buttonContainer}>
        <StyledIconButton
          className="button-add-with-label"
          label="Add Metric"
          onClick={onMetricAdd}
          cypress_id="create-campaign-add_metric-button"
        >
          <AddIcon />
        </StyledIconButton>
        <span className={classes.buttonLabel}>Add Metric</span>
      </div>
    </div>
  )
}

export default injectStyles(styles)(MetricsEdit)
